// Module
var code = "<div id=\"V-AFB6F553-8A88-4F27-A1F4-8F1EF7B7258A\"> <div data-b-component=\"loading\" data-b-comp-isloading=\"{Binding isLoading}\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding currentForm}\"></div> </div> </div> ";
// Exports
export default code;